import Image from "next/image"


const posts = [
  {
    title: 'Simple software connection',
    href: '#',
    category: { name: 'Step 1', href: '#', color: 'bg-emerald-100 text-emerald-800' },
    description: 'We have a simple point and click process to give us access to your acounting tools so we can see all your transactions.',
    imageUrl: '/connect.png',
    datetime: '2020-03-16',
  },
  {
    title: 'Plan with our Financial Architects',
    href: '#',
    category: { name: 'Step 2', href: '#', color: 'bg-emerald-100 text-emerald-800' },
    description: 'One of our financial architects will plan with you your forecasts & budgets as well as get a process in place to close your books monthly quickly.',
    imageUrl: '/pinto-report-in-hand.png',
    datetime: '2020-03-10',
  },
  {
    title: 'Sit back and wait for your first report',
    href: '#',
    category: { name: 'Step 3', href: '#', color: 'bg-emerald-100 text-emerald-800' },
    description: 'We close your books monthly by the 5th of every month and get you simple and powerful reports to know the exact status of your business\'s financial health.',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    imageUrl: '/pinto-complete.png',
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}



export default function HowItWorks() {
  return (
    <div className="bg-white px-4 pt-8 mb-12 sm:px-6 lg:px-8 lg:pt-8 lg:mb-12">
      <div className="relative mx-auto max-w-lg lg:max-w-7xl">
        <div>
          <h2 className="text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl text-center">How we architect success</h2>
          {/*<p className="mt-3 text-xl text-gray-500 sm:mt-4">
              Nullam risus blandit ac aliquam justo ipsum. Quam mauris volutpat massa dictumst amet. Sapien tortor lacus
              arcu.
            </p>*/}
        </div>
        <div className="mt-12 grid gap-16 pt-12 lg:grid-cols-3 lg:gap-x-5 lg:gap-y-12">
          {posts.map((post) => (
            <div key={post.title}>
              <div>
                <a href={post.category.href} className="inline-block">
                  <span
                    className={classNames(
                      post.category.color,
                      'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium'
                    )}
                  >
                    {post.category.name}
                  </span>
                </a>
              </div>
              <a href={post.href} className="mt-4 block">
                <Image width={222} height={192} className="h-48 rounded-full" src={post.imageUrl} alt="" unoptimized/>
                <p className="text-xl font-semibold text-gray-900">{post.title}</p>
                <p className="mt-3 text-base text-gray-500">{post.description}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  
  )
}



